import React from 'react';
import { Alert, Snackbar } from '@mui/material';

const FeedbackSnackbar = ({ open, severity, message, onClose }) => (
  <Snackbar
    open={open}
    autoHideDuration={3500}
    onClose={onClose}
    anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
  >
    <Alert onClose={onClose} severity={severity} variant="filled" sx={{ width: '100%' }}>
      {message}
    </Alert>
  </Snackbar>
);

export default FeedbackSnackbar;
